import React from 'react';
import { Store } from 'redux';
import { useSelector } from 'react-redux';
import { StyleSheet, css } from 'aphrodite/no-important';
import {
  AppContent,
  ErrorBoundary,
  AboutAuthors,
  AboutIntro,
  AboutContact,
  ContentWithoutSidebar,
  LARGE_SCREEN_SIZE,
  MEDIA_BREAKPOINTS,
} from 'mm-ui-components';
import { AboutAuthorsProps } from 'mm-ui-components/dist/src/base/components/about/AboutAuthors';
import { Page } from '../Page';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import { ErrorReporter } from '../../errorReporting/errorReporter.type';
import { MetaTags } from '../../components/connectedComponents/MetaTags';
import { useMeasureHydrateTime } from '../useMeasureHydrateTime';
import { HeadScripts } from '../../components/connectedComponents/HeadScripts';
import { Theme } from '../../components/connectedComponents/Theme';
import { NavigationLayout } from '../../components/connectedComponents/NavigationLayout';
import { getAbout, getAuthors } from '../../store/template/aboutPage/aboutPageSedona/aboutPageSedona.selectors';

const PAGE_TITLE = 'About Page';

interface AuthorPageProps {
  store: Store<AppState, AppActions>;
  errorProvider: ErrorReporter;
}

const createStyles = () => StyleSheet.create({
  sectionsWrapper: {
    margin: '0 40px',
    [MEDIA_BREAKPOINTS.small]: {
      margin: '0 16px',
    },
    [MEDIA_BREAKPOINTS.large]: {
      margin: '0',
    },
  },
});

export const AboutPageSedonaComponent: React.FunctionComponent<AuthorPageProps> = ({ store, errorProvider }) => {
  useMeasureHydrateTime();
  return (
    <Page store={store} errorProvider={errorProvider}>
      <ErrorBoundary>
        <AboutPageContentConnected />
      </ErrorBoundary>
    </Page>
  );
};

export const AboutPageContentConnected: React.FunctionComponent = () => {
  const styles = createStyles();
  const authors = useSelector(getAuthors);
  const about = useSelector(getAbout);

  return (
    <>
      <MetaTags title={PAGE_TITLE} description={null} pageImage={null} />
      <HeadScripts />
      <Theme>
        <AppContent>
          <NavigationLayout mainWrapperConfigThemeKey="mainContent">
            <ContentWithoutSidebar maxWidth={LARGE_SCREEN_SIZE}>
              <div className={css(styles.sectionsWrapper)}>
                <AboutIntro about={about} />
                <AboutAuthors authors={authors as AboutAuthorsProps[]} />
                <AboutContact />
              </div>
            </ContentWithoutSidebar>
          </NavigationLayout>
        </AppContent>
      </Theme>
    </>
  );
};
